export class SolicitacaoBens {
  nR_BPM_NUMERO_SOLICITACAO: number;
  cD_BPM_NR_BEM_PATRIMONIAL: string
  dS_BPM_DESCRICAO_BEM: string
  dS_BPM_NUMERO_SERIE: string
  dS_BPM_MARCA: string
  dS_BPM_MODELO: string
  dS_BPM_OUTROS: string
  cD_CDU_MATRICULA_SOLICITACAO: number;
  fL_SOLICITACAO_ATIVA: number
  dT_BPM_DATA_SOLICITACAO: Date;
  fL_ATIVO: number;
  fL_DELETADO: number;
}
